import { render, staticRenderFns } from "./ProjectBidTree.vue?vue&type=template&id=4df639b2"
import script from "./ProjectBidTree.vue?vue&type=script&lang=js"
export * from "./ProjectBidTree.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports